import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import type {CustomActionID} from '../types';

/**
 * `deleteCustomAction` request params
 * (what is used to send to server)
 */
export type DeleteCustomActionRequestOptions = {
	id: CustomActionID;
};

/**
 * `deleteCustomAction` request
 * (what gets sent to the server)
 */
export type DeleteCustomActionRequest = [
	DeleteCustomActionRequestOptions['id'],
];

/**
 * `deleteCustomAction` response
 * (what comes back from the server)
 */
export type DeleteCustomActionResponse =
	SuccessResponse<DeleteCustomActionResult>;

/**
 * `deleteCustomAction` result
 * (what is utilized from the server response)
 */
export type DeleteCustomActionResult = CustomActionID; // TODO: java code says it responds with just `DTO`

export const deleteCustomActionEndpoint = 'deleteCustomAction';

/**
 * Delete custom action
 */
export const deleteCustomAction = async (
	{id}: DeleteCustomActionRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: DeleteCustomActionRequest = [id];

	return client
		.post<DeleteCustomActionResponse>(
			deleteCustomActionEndpoint,
			requestParams,
			{signal},
		)
		.then((response) => response.data.result);
};

export default deleteCustomAction;
